import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import UpcaseController from "./upcase_controller"
application.register("upcase", UpcaseController)

import OffcanvasController from "./offcanvas_controller"
application.register("offcanvas", OffcanvasController)

import OffcanvasBodyController from "./offcanvas_body_controller"
application.register("offcanvas-body", OffcanvasBodyController)

import ConfirmationModalController from "./confirmation_modal_controller"
application.register("confirmation-modal", ConfirmationModalController)

import ImageModalController from "./image_modal_controller"
application.register("image-modal", ImageModalController)

import TeamGridController from "./team_grid_controller"
application.register("team-grid", TeamGridController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import B2cGalleryController from "./b2c_gallery_controller"
application.register("b2c-gallery", B2cGalleryController)

import BoardController from "./board_controller"
application.register("board", BoardController)

import CartItemController from "./cart_item_controller"
application.register("cart-item", CartItemController)

import CheckoutController from "./checkout_controller"
application.register("checkout", CheckoutController)

import AjaxFormController from "./ajax_form_controller"
application.register("ajax-form", AjaxFormController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import ColorSelect2Controller from "./color_select2_controller"
application.register("color-select2", ColorSelect2Controller)

import TeamFormController from "./team_form_controller"
application.register("team-form", TeamFormController)

import LogoRequestFormController from "./logo_request_form_controller"
application.register("logo-request-form", LogoRequestFormController)

import PlayerSetupController from "./player_setup_controller"
application.register("player-setup", PlayerSetupController)

import "./side_dialog_controller"
import "./dialog_controller"

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import DraggableController from "./draggable_controller"
application.register("draggable", DraggableController)
